import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconDisallowSvg } from "./IconDisallowSvg.mjs";
const IconDisallow = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconDisallowSvg, ...svgProps }) });
export {
  IconDisallow
};
